import React from "react";
import { getCardUrl } from "@/utils/utils";
import { Row, Col, Card, Tag, Alert } from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

{
    /* NLH, 6+, PLO, AOF, MTT */
}
export default function HandDetail({
    handCardData = {},
    squidConf = {},
    searchPlayer = {},
    language = {},
}) {
    searchPlayer = {
        uid1: searchPlayer.uid1 ? searchPlayer.uid1 : undefined,
        uid2: searchPlayer.uid2 ? searchPlayer.uid2 : undefined,
    };
    return (
        <>
            {/* result */}
            {handCardData.board_result && (
                <Card
                    title={
                        <>
                            <span>
                                {language["pot"]}：{handCardData.board_result.pots}
                            </span>
                            <span className="ml10">
                                {language["playerNumber"]}：{handCardData.board_result.player}
                            </span>
                        </>
                    }
                    type="inner"
                    size="small"
                >
                    {handCardData.board_result.board_cards &&
                        handCardData.board_result.board_cards.length && (
                            <Row type="flex" align="middle">
                                <span className="ml20">{language["commonCard"]}：</span>
                                <span>
                                    {handCardData.board_result.board_cards.map((item, index) => (
                                        <img
                                            key={index}
                                            className="board-img"
                                            src={getCardUrl(item)}
                                        />
                                    ))}
                                </span>
                            </Row>
                        )}
                    {handCardData.players_result &&
                        handCardData.players_result.length &&
                        handCardData.players_result.map((item, index) => (
                            <Alert
                                className="mt10"
                                type={
                                    item.user_name.indexOf(searchPlayer.uid1) > -1
                                        ? "info"
                                        : item.user_name.indexOf(searchPlayer.uid2) > -1
                                            ? "error"
                                            : "none"
                                }
                                message={
                                    <Row
                                        type="flex"
                                        align="middle"
                                        key={index}
                                    >
                                        <Col span={isMobileDevice() ? 24 : 7} align="left">
                                            <Tag color="geekblue">{item.position}</Tag>
                                            <span>{item.user_name}</span>
                                        </Col>
                                        <Col span={isMobileDevice() ? 24 : 10} align={isMobileDevice() ? "left" : "center"}>
                                            {item.hole_cards &&
                                                item.hole_cards.length &&
                                                item.hole_cards.map((item2, index2) => (
                                                    <img
                                                        key={index2}
                                                        className="board-img"
                                                        src={getCardUrl(item2)}
                                                    />
                                                ))}
                                            <span className="ml20 mr10">{item.card_type}</span>
                                            {item.make_cards &&
                                                item.make_cards.length &&
                                                item.make_cards.map((item2, index2) => (
                                                    <img
                                                        key={index2}
                                                        className="board-img"
                                                        src={getCardUrl(item2)}
                                                    />
                                                ))}
                                        </Col>
                                        <Col span={isMobileDevice() ? 24 : 7} align={isMobileDevice() ? "left" : "right"}>
                                            <Row>
                                                <Col>
                                                    <span
                                                        className="fs18"
                                                        style={{
                                                            color:
                                                                item.income > 0
                                                                    ? "#cf1322"
                                                                    : item.income < 0
                                                                        ? "#3f8600"
                                                                        : "",
                                                        }}
                                                    >
                                                        {item.income > 0 ? "+" : ""}
                                                        {item.income / 100}
                                                    </span>
                                                </Col>
                                                <Col>
                                                    {item.two_seven_result != 0 && (
                                                        <>
                                                            <span className="fs12">27：</span>
                                                            <span
                                                                className="fs12 mr10"
                                                                style={{
                                                                    color:
                                                                        item.two_seven_result > 0
                                                                            ? "#cf1322"
                                                                            : item.two_seven_result < 0
                                                                                ? "#3f8600"
                                                                                : "",
                                                                }}
                                                            >
                                                                {item.two_seven_result > 0 ? "+" : ""}
                                                                {item.two_seven_result / 100}
                                                            </span>
                                                        </>
                                                    )}
                                                    {item.insurance_income != 0 && (
                                                        <>
                                                            <span className="fs12">
                                                                {language["insurance"]}：
                                                            </span>
                                                            <span
                                                                className="fs12"
                                                                style={{
                                                                    color:
                                                                        item.insurance_income > 0
                                                                            ? "#cf1322"
                                                                            : item.insurance_income < 0
                                                                                ? "#3f8600"
                                                                                : "",
                                                                }}
                                                            >
                                                                {item.insurance_income > 0 ? "+" : ""}
                                                                {item.insurance_income / 100}
                                                            </span>
                                                        </>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                }
                            />
                        ))}

                    {/* 赢得鱿鱼玩家 */}
                    {handCardData.squid_winner && (
                        <Alert
                            className="mt20"
                            type={
                                String(handCardData.squid_winner.uid).indexOf(
                                    searchPlayer.uid1
                                ) > -1
                                    ? "info"
                                    : String(handCardData.squid_winner.uid).indexOf(
                                        searchPlayer.uid2
                                    ) > -1
                                        ? "error"
                                        : "none"
                            }
                            message={
                                <Row type="flex" align="middle">
                                    <Col span={isMobileDevice() ? 24 : 12} align="left">
                                        <span>{`${handCardData.squid_winner.userName} (ID:${handCardData.squid_winner.uid})`}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 12} align={isMobileDevice() ? "left" : "right"}>
                                        <span>
                                            {language["winSquid"]}：x
                                            {handCardData.squid_winner.squidCount}
                                        </span>
                                    </Col>
                                </Row>
                            }
                        />
                    )}
                </Card>
            )}

            {/* 鱿鱼结算 */}
            {handCardData.squid_balances &&
                handCardData.squid_balances.length > 0 && (
                    <Card
                        className="mt10"
                        title={
                            <>
                                <span>{language["squidResult"]}</span>
                                {squidConf.mode === 1 && (
                                    <Tag color="blue" className="ml10">
                                        {language["singleMode"]}
                                    </Tag>
                                )}
                                {squidConf.mode === 2 && (
                                    <Tag color="geekblue" className="ml10">
                                        {language["normalMode"]}
                                    </Tag>
                                )}
                                {squidConf.mode === 3 && (
                                    <Tag color="purple" className="ml10">
                                        {language["crazyModel"]}
                                    </Tag>
                                )}
                            </>
                        }
                        type="inner"
                        size="small"
                    >
                        {handCardData.squid_balances.map((item, index) => (
                            <Alert
                                className="mt10"
                                type={
                                    String(item.uid).indexOf(searchPlayer.uid1) > -1
                                        ? "info"
                                        : String(item.uid).indexOf(searchPlayer.uid2) > -1
                                            ? "error"
                                            : "none"
                                }
                                message={
                                    <Row
                                        type="flex"
                                        align="middle"
                                        key={index}
                                    >
                                        <Col span={isMobileDevice() ? 24 : 8} align="left">
                                            <span>{`${item.userName} (ID:${item.uid})`}</span>
                                        </Col>
                                        <Col span={isMobileDevice() ? 24 : 8} align={isMobileDevice() ? "left" : "center"}>
                                            <span>
                                                {item.squidCount > 0
                                                    ? language["winSquid"] + "：x" + item.squidCount
                                                    : ""}
                                            </span>
                                        </Col>
                                        <Col span={isMobileDevice() ? 24 : 8} align={isMobileDevice() ? "left" : "right"}>
                                            <span
                                                className="fs18"
                                                style={{
                                                    color:
                                                        item.balance > 0
                                                            ? "#cf1322"
                                                            : item.balance < 0
                                                                ? "#3f8600"
                                                                : "",
                                                }}
                                            >
                                                {item.balance > 0 ? "+" : ""}
                                                {item.balance / 100}
                                            </span>
                                        </Col>
                                    </Row>
                                }
                            />
                        ))}
                    </Card>
                )}

            {/* Rounds */}
            {handCardData.rounds &&
                handCardData.rounds.length > 0 &&
                handCardData.rounds.map((item, index) => (
                    <Card
                        className="mt10"
                        key={index}
                        title={
                            <>
                                <span>{item.gstate}</span>
                                <span className="ml10">
                                    {language["pot"]}：{item.round_pot / 100}
                                </span>
                                <span className="ml10">
                                    {language["playerNumber"]}：{item.round_player}
                                </span>
                            </>
                        }
                        type="inner"
                        size="small"
                    >
                        {item.round_board_cards && item.round_board_cards.length && (
                            <Row type="flex" align="middle">
                                <span className="ml20">{language["commonCard"]}：</span>
                                <span>
                                    {item.round_board_cards.map((item2, index2) => (
                                        <img
                                            key={index2}
                                            className="board-img"
                                            src={getCardUrl(item2)}
                                        />
                                    ))}
                                </span>
                            </Row>
                        )}
                        {item.actions &&
                            item.actions.length &&
                            item.actions.map((item2, index2) => (
                                <Alert
                                    className="mt10"
                                    type={
                                        item2.user_name.indexOf(searchPlayer.uid1) > -1
                                            ? "info"
                                            : item2.user_name.indexOf(searchPlayer.uid2) > -1
                                                ? "error"
                                                : "none"
                                    }
                                    message={
                                        <Row
                                            type="flex"
                                            align="middle"
                                            key={index2}
                                        >
                                            <Col span={isMobileDevice() ? 24 : 12} align="left">
                                                <Tag color="geekblue">{item2.position}</Tag>
                                                <span>{item2.user_name}</span>
                                            </Col>
                                            <Col span={isMobileDevice() ? 24 : 12} align={isMobileDevice() ? "left" : "right"}>
                                                {item2.force_blind && <span>{language["blind"]}</span>}
                                                <span className="ml10">
                                                    {item2.opt}：{item2.chips / 100}
                                                </span>
                                                <span className="ml10">
                                                    {language["remoteHolder"]}：{item2.echips / 100}
                                                </span>
                                            </Col>
                                        </Row>
                                    }
                                />
                            ))}
                    </Card>
                ))}

            {/* 保险 */}
            {handCardData.insurance_detail &&
                handCardData.insurance_detail.length > 0 && (
                    <Card
                        className="mt10"
                        title={language["insurance"]}
                        type="inner"
                        size="small"
                    >
                        {handCardData.insurance_detail.map((item, index) => (
                            <Alert
                                className="mt10"
                                type={
                                    item.user_name.indexOf(searchPlayer.uid1) > -1
                                        ? "info"
                                        : item.user_name.indexOf(searchPlayer.uid2) > -1
                                            ? "error"
                                            : "none"
                                }
                                message={
                                    <Row
                                        type="flex"
                                        align="middle"
                                        key={index}
                                    >
                                        <Col span={isMobileDevice() ? 24 : 12} align="left">
                                            {item.position && (
                                                <Tag color="geekblue">{item.position}</Tag>
                                            )}
                                            <span>{item.user_name}</span>
                                        </Col>
                                        <Col span={isMobileDevice() ? 24 : 12} align={isMobileDevice() ? "left" : "right"}>
                                            <span className="ml10">
                                                {language["buy"]}：{item.buy / 100}
                                            </span>
                                            <span className="ml10">
                                                {language["compensate"]}：{item.pay / 100}
                                            </span>
                                            <span className="ml10">
                                                {language["pot"]}：{item.pot_chips / 100}
                                            </span>
                                            <span className="ml10">
                                                {language["odds"]}：{item.odds}
                                            </span>
                                            <span className="ml10">
                                                {item.round === "turn"
                                                    ? language["transferCards"]
                                                    : language["drawCards"]}
                                            </span>
                                            <span className="ml10">
                                                {item.passive
                                                    ? language["passivePurchase"]
                                                    : language["activePurchase"]}
                                            </span>
                                        </Col>
                                    </Row>
                                }
                            />
                        ))}
                    </Card>
                )}

            {/* Win */}
            {handCardData.show_down && handCardData.show_down.length > 0 && (
                <Card className="mt10" title="Win" type="inner" size="small">
                    {handCardData.show_down.map((item, index) => (
                        <Alert
                            className="mt10"
                            type={
                                item.user_name.indexOf(searchPlayer.uid1) > -1
                                    ? "info"
                                    : item.user_name.indexOf(searchPlayer.uid2) > -1
                                        ? "error"
                                        : "none"
                            }
                            message={
                                <Row
                                    type="flex"
                                    align="middle"
                                    key={index}
                                >
                                    <Col span={isMobileDevice() ? 24 : 7} align="left">
                                        <Tag color="geekblue">{item.position}</Tag>
                                        <span>{item.user_name}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 10} align={isMobileDevice() ? "left" : "center"}>
                                        <span className="mr10">{language["handCard"]}</span>
                                        {item.hole_cards &&
                                            item.hole_cards.length &&
                                            item.hole_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml20 mr10">{item.card_type}</span>
                                        {item.make_cards &&
                                            item.make_cards.length &&
                                            item.make_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 7} align={isMobileDevice() ? "left" : "right"}>
                                        <Row>
                                            <Col>
                                                <span
                                                    className="fs18"
                                                    style={{
                                                        color:
                                                            item.income > 0
                                                                ? "#cf1322"
                                                                : item.income < 0
                                                                    ? "#3f8600"
                                                                    : "",
                                                    }}
                                                >
                                                    {item.income > 0 ? "+" : ""}
                                                    {item.income / 100}
                                                </span>
                                            </Col>
                                            <Col>
                                                {item.insurance_income != 0 && (
                                                    <>
                                                        <span className="fs12">
                                                            {language["insurance"]}：
                                                        </span>
                                                        <span
                                                            className="fs12"
                                                            style={{
                                                                color:
                                                                    item.insurance_income > 0
                                                                        ? "#cf1322"
                                                                        : item.insurance_income < 0
                                                                            ? "#3f8600"
                                                                            : "",
                                                            }}
                                                        >
                                                            {item.insurance_income > 0 ? "+" : ""}
                                                            {item.insurance_income / 100}
                                                        </span>
                                                    </>
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            }
                        />
                    ))}
                </Card>
            )}
        </>
    );
}
